module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc5-f291ce099245ba493ab1b35f27a5e866.jpg";